(() => {
  const from = 'Plan delivered in 5 days';
  const to = 'Plan delivered in 5 business days';
  const isQuestionnaire = () => window.location.pathname === '/pages/questionnaire' || document.querySelector('.tst-app, .qhead');
  const updateConfig = () => {
    if (!window.TST_CONFIG || !window.TST_CONFIG.welcome) return;
    if (window.TST_CONFIG.welcome.meta3 === from) window.TST_CONFIG.welcome.meta3 = to;
  };
  const updateText = () => {
    if (!isQuestionnaire()) return;
    updateConfig();
    const root = document.querySelector('.tst-app') || document.body;
    if (!root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.includes(from)) node.nodeValue = node.nodeValue.split(from).join(to);
    }
  };
  updateText();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateText); else updateText();
  window.addEventListener('load', updateText);
  document.addEventListener('click', () => requestAnimationFrame(updateText), true);
})();

(() => {
  const STORE_KEY = 'tstQuestionnaireConsents';
  const IDS = {
    privacy: 'tst-privacy-policy-acknowledgement',
    sensitive: 'tst-sensitive-data-consent'
  };
  const FIELD_KEYS = {
    privacy: 'privacyPolicyAcknowledgement',
    sensitive: 'sensitiveDataConsent'
  };
  const isQuestionnaire = () => /\/pages\/questionnaire\b/.test(window.location.pathname) || document.querySelector('.tst-app, .qhead, .stage');

  const stateAnswers = () => {
    try {
      if (typeof STATE !== 'undefined') {
        STATE.answers = STATE.answers || {};
        return STATE.answers;
      }
    } catch (error) {}
    return null;
  };

  const readStored = () => {
    try { return JSON.parse(localStorage.getItem(STORE_KEY) || '{}') || {}; } catch (error) { return {}; }
  };

  const writeStored = (next) => {
    try { localStorage.setItem(STORE_KEY, JSON.stringify(next)); } catch (error) {}
  };

  const setAnswer = (key, value) => {
    const answers = stateAnswers();
    if (answers) answers[FIELD_KEYS[key]] = Boolean(value);
    const stored = readStored();
    stored[FIELD_KEYS[key]] = Boolean(value);
    writeStored(stored);
    try { if (typeof saveState === 'function') saveState(); } catch (error) {}
  };

  const getAnswer = (key) => {
    const answers = stateAnswers();
    if (answers && Object.prototype.hasOwnProperty.call(answers, FIELD_KEYS[key])) return Boolean(answers[FIELD_KEYS[key]]);
    return Boolean(readStored()[FIELD_KEYS[key]]);
  };

  const ensureStyle = () => {
    if (document.getElementById('tst-questionnaire-consent-style')) return;
    const style = document.createElement('style');
    style.id = 'tst-questionnaire-consent-style';
    style.textContent = '.tst-consent{margin:14px 0 12px;padding:12px 14px;border:1px solid rgba(241,236,224,.16);border-radius:8px;background:rgba(241,236,224,.04);color:var(--c-bone,#f1ece0)}.tst-consent__title{margin:0 0 8px;font-size:11px;font-weight:800;letter-spacing:.08em;text-transform:uppercase;color:var(--c-amber,#e97826)}.tst-consent__row{display:grid;grid-template-columns:20px minmax(0,1fr);gap:9px;align-items:flex-start;margin:8px 0;font-size:13px;line-height:1.35}.tst-consent__row input{width:17px;height:17px;margin:0;accent-color:var(--c-amber,#e97826)}.tst-consent__row a{color:var(--c-amber,#e97826);text-decoration:underline;text-underline-offset:3px}.tst-consent__error{display:none;margin:8px 0 0;color:#ffb199;font-size:12px;font-weight:700}.tst-consent[data-error="true"] .tst-consent__error{display:block}@media(max-width:760px){.tst-consent{padding:12px}.tst-consent__row{font-size:12.5px}}';
    document.head.appendChild(style);
  };

  const consentMarkup = () => `
    <p class="tst-consent__title">Before you continue</p>
    <label class="tst-consent__row" for="${IDS.privacy}">
      <input id="${IDS.privacy}" type="checkbox" required>
      <span>I have read the <a href="/policies/privacy-policy" target="_blank" rel="noopener">Privacy Policy</a>.</span>
    </label>
    <label class="tst-consent__row" for="${IDS.sensitive}">
      <input id="${IDS.sensitive}" type="checkbox" required>
      <span>I consent to sharing health and fitness details for coaching.</span>
    </label>
    <p class="tst-consent__error" role="alert">Please tick both boxes to continue.</p>`;

  const syncInputs = (box) => {
    const privacy = box.querySelector(`#${IDS.privacy}`);
    const sensitive = box.querySelector(`#${IDS.sensitive}`);
    if (privacy) privacy.checked = getAnswer('privacy');
    if (sensitive) sensitive.checked = getAnswer('sensitive');
  };

  const inject = () => {
    if (!isQuestionnaire()) return null;
    ensureStyle();
    const app = document.querySelector('.tst-app, .stage, main') || document.body;
    if (!app) return null;
    let box = document.getElementById('tst-questionnaire-consent');
    if (!box) {
      box = document.createElement('section');
      box.id = 'tst-questionnaire-consent';
      box.className = 'tst-consent';
      box.setAttribute('aria-label', 'Required acknowledgements');
      box.innerHTML = consentMarkup();
    }
    const footer = document.querySelector('.qfoot, #btn-next') || null;
    if (footer && footer.parentElement && box.parentElement !== footer.parentElement) footer.parentElement.insertBefore(box, footer);
    else if (!box.parentElement) app.appendChild(box);
    syncInputs(box);
    return box;
  };

  const allChecked = () => {
    const box = inject();
    if (!box) return true;
    const privacy = box.querySelector(`#${IDS.privacy}`);
    const sensitive = box.querySelector(`#${IDS.sensitive}`);
    return Boolean(privacy && sensitive && privacy.checked && sensitive.checked);
  };

  const showError = () => {
    const box = inject();
    if (!box) return;
    box.dataset.error = 'true';
    box.scrollIntoView({ block: 'center', behavior: 'smooth' });
  };

  const clearError = () => {
    const box = document.getElementById('tst-questionnaire-consent');
    if (box) box.dataset.error = 'false';
  };

  document.addEventListener('change', (event) => {
    if (!isQuestionnaire()) return;
    const target = event.target;
    if (!target || !target.id) return;
    if (target.id === IDS.privacy) setAnswer('privacy', target.checked);
    if (target.id === IDS.sensitive) setAnswer('sensitive', target.checked);
    if (allChecked()) clearError();
  }, true);

  document.addEventListener('click', (event) => {
    if (!isQuestionnaire()) return;
    const forward = event.target && event.target.closest && event.target.closest('#btn-next, #open-pay-modal, .qhead__pay, [data-review-submit]');
    if (!forward) return;
    inject();
    if (allChecked()) {
      setAnswer('privacy', true);
      setAnswer('sensitive', true);
      clearError();
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    showError();
  }, true);

  const run = () => {
    const box = inject();
    if (!box) return;
    syncInputs(box);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('click', () => requestAnimationFrame(run), true);
  const observer = new MutationObserver(() => requestAnimationFrame(run));
  if (document.documentElement) observer.observe(document.documentElement, { childList: true, subtree: true });
})();
